import { SchemaAudioLibraryService } from '@frontend/schema';
import {
  DeleteAudioLibraryTypes,
  ListAudioLibraryTypes,
  RenameAudioLibraryTypes,
  UsageAudioLibraryTypes,
  UsageV2AudioLibraryTypes,
  TTSLanguagesAudioLibraryTypes,
  TTSVoicesAudioLibraryTypes,
} from './types';

export const listAudioLibrary = (req: ListAudioLibraryTypes['input']): Promise<ListAudioLibraryTypes['output']> => {
  return SchemaAudioLibraryService.List(req);
};

export const renameAudioLibrary = (
  req: RenameAudioLibraryTypes['input']
): Promise<RenameAudioLibraryTypes['output']> => {
  return SchemaAudioLibraryService.Rename(req);
};

export const deleteAudioLibrary = (
  req: DeleteAudioLibraryTypes['input']
): Promise<DeleteAudioLibraryTypes['output']> => {
  return SchemaAudioLibraryService.Delete(req);
};

export const getAudioLibraryUsage = (
  req: UsageAudioLibraryTypes['input']
): Promise<UsageAudioLibraryTypes['output']> => {
  return SchemaAudioLibraryService.Usage(req);
};

export const getAudioLibraryUsageV2 = (
  req: UsageV2AudioLibraryTypes['input']
): Promise<UsageV2AudioLibraryTypes['output']> => {
  return SchemaAudioLibraryService.UsageV2(req);
};

export const getAudioLibraryLanguages = (
  req: TTSLanguagesAudioLibraryTypes['input']
): Promise<TTSLanguagesAudioLibraryTypes['output']> => {
  return SchemaAudioLibraryService.TTSLanguages(req);
};

export const getAudioLibraryVoices = (
  req: TTSVoicesAudioLibraryTypes['input']
): Promise<TTSVoicesAudioLibraryTypes['output']> => {
  return SchemaAudioLibraryService.TTSVoices(req);
};
